import { render, staticRenderFns } from "./MatterFirstInstanceCourtList.vue?vue&type=template&id=78f5d5d7&"
import script from "./MatterFirstInstanceCourtList.vue?vue&type=script&lang=js&"
export * from "./MatterFirstInstanceCourtList.vue?vue&type=script&lang=js&"
import style0 from "./MatterFirstInstanceCourtList.vue?vue&type=style&index=0&id=78f5d5d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports